import React from 'react'
import classes from './Skeleton.module.scss';

export default function SkeletonItem({style}) {
    return (
        <div className={classes.skeleton} style={style}><strong></strong></div>
    )
}
